module.exports = __webpack_public_path__ + "img/chart-pie.2e405003.svg";